// PO 2026-02 · Root-domain marketing Sign In → canonical auth host.
//
// Rationale: `jobclose.ai` is the public marketing surface and
// `app.jobclose.ai` is the canonical application/auth host. When the
// marketing site is served on `jobclose.ai`, its Sign In CTA must
// point at the canonical login on `app.jobclose.ai` — NOT the
// same-origin `/login` on the marketing host — so returning
// contractors always land at the canonical app.
//
// Configuration is baked at build time via `REACT_APP_AUTH_ORIGIN`.
// * Marketing build (jobclose.ai): set to `https://app.jobclose.ai`.
// * App build (app.jobclose.ai): leave unset — same-origin routing
//   preserves normal in-app auth navigation.
//
// This module is the ONE place components read that value. Callsites
// use ``<SigninLink>`` from ``components/common/SigninLink.jsx`` so no
// component hard-codes a domain.

// CRA / webpack DefinePlugin literally substitutes
// ``process.env.REACT_APP_*`` at build time with the value present in
// ``frontend/.env`` at build. We MUST reference it as the bare
// expression (not gated behind ``typeof process``) or the plugin
// leaves the code intact and it evaluates to ``"undefined"`` in the
// browser.
const RAW = String(process.env.REACT_APP_AUTH_ORIGIN || "").trim();

// Only accept an http(s) origin. Anything else is treated as unset so
// same-origin fallback wins deterministically.
const isSafe = /^https?:\/\/[^\s/]+/i.test(RAW);

/** Trailing-slash-free absolute origin, or empty string when unset. */
export const AUTH_ORIGIN = isSafe ? RAW.replace(/\/+$/, "") : "";

/** True when the marketing build should route auth to a canonical host. */
export const hasCanonicalAuthOrigin = Boolean(AUTH_ORIGIN);

/** Return the absolute login URL, or the same-origin `/login` when unset. */
export function loginHref() {
  return AUTH_ORIGIN ? `${AUTH_ORIGIN}/login` : "/login";
}
